import type { PageMetadata } from "../lib/metadata";
import seo from "./slow-seo.json";

export function slowPageMetadata(
  siteURL: string,
  privateRoom: boolean,
): PageMetadata {
  const site = siteURL.replace(/\/$/, "");
  const canonical = `${site}/relax/slow`;
  if (privateRoom)
    return {
      title: "私有慢互动 - 微言工具箱",
      description: "仅受邀者可查看的私有慢互动。",
      canonical,
      noIndex: true,
    };
  return {
    title: seo.title,
    description: seo.description,
    canonical,
    image: `${site}/brand/wyan-toolbox-mark.png`,
    keywords: seo.keywords,
    structuredData: [
      {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        name: seo.name,
        description: seo.description,
        url: canonical,
        applicationCategory: "GameApplication",
        operatingSystem: "Any",
        inLanguage: "zh-CN",
        isAccessibleForFree: true,
        offers: { "@type": "Offer", price: "0", priceCurrency: "CNY" },
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "松弛休闲",
            item: `${site}/relax`,
          },
          { "@type": "ListItem", position: 2, name: seo.name, item: canonical },
        ],
      },
    ],
  };
}
